// import ModalGeneric from "  ./_add_popup/_component";

import ModalGeneric from 'modules/my-sales/submodules/leads/list/widgets/ModalGenericPopup';
import { useShippingSearchFooter } from './_hook';

const ShippingSearchFooterComponent = () => {
  const {
    modalOpen,
    cleanChannelLead,
    cleanCreateLead,
    setModalOpen,
    createLeadObj,
    selectChannel,
    setSelectChannel,
    CreateLead,
    setDropdownOptionsChannels,
    dropdownOptionsChannels,
  } = useShippingSearchFooter();

  return (
    <>
      {modalOpen && (
        <ModalGeneric
          cleanChannelLead={cleanChannelLead}
          cleanCreateLead={cleanCreateLead}
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
          createLeadObj={createLeadObj}
          selectChannel={selectChannel}
          setSelectChannel={setSelectChannel}
          CreateLead={CreateLead}
          setDropdownOptionsChannels={setDropdownOptionsChannels}
          dropdownOptionsChannels={dropdownOptionsChannels}
        />
      )}
    </>
  );
};

export default ShippingSearchFooterComponent;
